export enum Stages {
  SELECT_DATE_AND_TIME,
  FILL_USER_DATA,
  CONFIRMATION
}
